import api from './client';

export const integrationsAPI = {
  list: () => api.get('/api/admin/integrations/'),
};
